import { Component, Input, OnInit } from '@angular/core'
import { PageContext, RedirectorDomainCatchConfig } from 'src/app/service/redirector.service'
import { IconComponent } from 'src/app/elements/icon/icon.component'
import { I18nSelectorComponent } from 'src/app/elements/i18n-selector/i18n-selector.component'
import { RouterLink } from '@angular/router'
import { ButtonComponent } from 'src/app/elements/button/button.component'
import { UserTokenPipe } from 'src/app/pipes/promo-link.pipe'

@Component({
  selector: 'app-domain-catch',
  templateUrl: './domain-catch.component.html',
  styleUrl: './domain-catch.component.sass',
  imports: [
    IconComponent,
    I18nSelectorComponent,
    RouterLink,
    ButtonComponent,
    UserTokenPipe,
  ],
})
export class DomainCatchComponent implements OnInit {
  @Input() context!: PageContext<RedirectorDomainCatchConfig>

  constructor () {
  }

  ngOnInit () {
  }
}
